{appStore}   = require 'stores'

module.exports = (opts) ->
  componentWillMount: ->
    if opts
      action = if opts.update then 'update' else 'set'
    else
      action = 'set'
    appStore.actions["#{action}Header"](opts)
